export default __webpack_public_path__ + "static/media/logo-footer.347c0d79.png";